import React, { useState } from 'react';
import { IconButton, AvatarImage } from 'components';
import styles from './AddedPerson.module.scss';
import { icons } from 'assets';
import { getMainImageSrcForObj } from 'utilities';

interface Props {
  person: any;
  removePerson: (id: number) => void;
}

const AddedPerson = (props: Props) => {
  const [hovered, setHovered] = useState(false);
  const { person, removePerson } = props;

  return (
    <div
      className={styles.addedPerson}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <AvatarImage
        size={70}
        src={getMainImageSrcForObj(person)}
        alt={person.name}
      />
      <p>{person.name}</p>


      <IconButton
        icon={icons.closeX}
        className={
          `${styles.removePersonBttn} ${hovered ? styles.visibleBttn : ''}`
        }
        onClick={() => removePerson(person.id)}
      />
    </div>
  );
}

export default AddedPerson;
